import React, { useState } from 'react';
import styled from 'styled-components';
import Viewer from 'react-viewer';
import { ConnectorDictionaryItemScreenshot } from './ConnectorTypes';
import { MQ } from '../../../style/MediaQueryHelpers';
import { useWindowSize } from '../../../utils/useWindowSize';

const ImageThumbContainer = styled.div`
	background: #00a89626;
	border-radius: 2px;
	border-top: 3px #00a896a8 solid;
	border-bottom: 3px #00a896a8 solid;
	margin-top: 100px;

	${MQ.W640} {
		margin-top: 50px;
	}
`;

const ImageThumbWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-around;
	margin-bottom: 30px;
`;

const Title = styled.h2`
	margin-left: 20px;
	margin-top: 20px;
	margin-bottom: 0;
	color: #00a896;
	font-size: 24px;
`;

const ThumbImg = styled.img`
	border: 1px solid #f7f6fa;
	border-radius: 5px;
	margin-top: 30px;
	cursor: pointer;
	height: 200px;

	${MQ.W640} {
		height: auto;
		width: 90%;
	}
`;

type ConnectorScreenshotsProps = {
	items?: ConnectorDictionaryItemScreenshot[];
};

const ConnectorScreenshots: React.FC<ConnectorScreenshotsProps> = (props) => {
	const windowSize = useWindowSize();
	const [visible, setVisible] = useState(false);
	const [index, setIndex] = useState(0);

	if (!props.items || props.items.length === 0) {
		return null;
	}

	const isMobileWidth = MQ.isMobileWidth(windowSize?.width);

	return (
		<ImageThumbContainer>
			<Title>SCREENSHOTS</Title>
			<ImageThumbWrapper>
				{props.items.map((x, i) => (
					<ThumbImg
						key={x.src}
						src={isMobileWidth ? x.mobile : x.thumbnail}
						alt={x.alt}
						onClick={() => {
							if (!isMobileWidth) {
								setIndex(i);
								setVisible(true);
							}
						}}
					/>
				))}
			</ImageThumbWrapper>
			<Viewer
				visible={visible}
				onClose={() => {
					setVisible(false);
				}}
				images={props.items}
				activeIndex={index}
				rotatable={false}
				scalable={false}
				attribute={false}
				noToolbar={true}
				noNavbar={true}
				noImgDetails={true}
				noFooter={true}
			/>
		</ImageThumbContainer>
	);
};
export default ConnectorScreenshots;
